import enReport from './locales/en/report.json' with { type: 'json' }
import nbReport from './locales/nb/report.json' with { type: 'json' }
import { uiLocaleToLanguageCode, type UiLocale } from '../core/contracts.js'

const REPORT_LOCALES = { en: enReport, nb: nbReport } as const

function lookup(obj: Record<string, unknown>, key: string): string | undefined {
  const parts = key.split('.')
  let node: unknown = obj
  for (const part of parts) {
    if (!node || typeof node !== 'object' || !(part in node)) return undefined
    node = (node as Record<string, unknown>)[part]
  }
  return typeof node === 'string' ? node : undefined
}

export function tReport(
  key: string,
  locale: UiLocale,
  vars?: Record<string, string>
): string {
  let text = lookup(REPORT_LOCALES[locale], key) ?? lookup(REPORT_LOCALES.en, key) ?? key
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      text = text.split(`{{${k}}}`).join(v)
    }
  }
  return text
}

export function reportHtmlLang(locale: UiLocale): string {
  return uiLocaleToLanguageCode(locale)
}

export function tRecommendedSolution(
  solution: string | undefined,
  locale: UiLocale
): string {
  if (!solution) return tReport('solutions.diagnosticCall', locale)
  const normalized = solution.toLowerCase()
  const translated = tReport(`solutions.${normalized}`, locale)
  if (translated !== `solutions.${normalized}`) {
    return translated.charAt(0).toUpperCase() + translated.slice(1)
  }
  return solution.charAt(0).toUpperCase() + solution.slice(1)
}

export function formatReportDate(dateInput: string | Date, locale: UiLocale): string {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput)
  if (Number.isNaN(date.getTime())) {
    return typeof dateInput === 'string' ? dateInput : ''
  }
  return date.toLocaleDateString(reportHtmlLang(locale), {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
